import { render, staticRenderFns } from "./VFullBroker.vue?vue&type=template&id=30825f48"
import script from "./VFullBroker.vue?vue&type=script&lang=js"
export * from "./VFullBroker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports